export enum chargerDates {
    yearly = 1,
    Monthly = 2,
    OneTime = 2,
}